import Is from "core/utility/is";
import React from "react";
import { Route } from "../types";

type MiddlewareProps = {
  route: Route;
};

export default function Middleware(props: MiddlewareProps) {
  const { route } = props;

  if (!Is.empty(route.middleware)) {
    const middlewareList: any = Is.array(route.middleware)
      ? route.middleware
      : [route.middleware];


    for (let middleware of middlewareList as Function[]) {
      const output = middleware();

      if (output) {
        return output;
      }
    }
  }

  return <route.component />;
}
